import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
import Index from '@/pages/index/index'
import Get from '@/pages/get/get'
import Page404 from '@/pages/page404/page404'

Vue.use(Router)

export default new Router({
  mode: 'history', // 什么意思？
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: '/get/:fid',
      name: 'Get',
      component: Get
    },
    {
      path: '/404',
      component: Page404
    },
    {
      path: '*',
      redirect: '/404'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js